import React,{useState,useEffect,useCallback} from 'react'
import { useParams } from 'react-router-dom'
import Loading from '../common/Loading'
import surveyService from '../../services/survey.service'
import { useEyeconxStore } from '../../store/eyeconxStore'
import EcxSurveyEditor from '../helpers/ecxsurvey/EcxSurveyEditor'
import { useSurveyStore } from '../helpers/ecxsurvey/surveyutilities/surveyStore'
import { toast } from 'react-toastify'

function SurveyEdit() {
  const {setSurvey,resetSurvey} = useEyeconxStore()
  const {surveyId} = useParams()
  const adminClinicId = useEyeconxStore((state)=>state.user.clinicId)
  const exportToJSON = useSurveyStore(state => state.exportToJSON)
  const [loading,setLoading] = useState(false)

  const getSurveyInfo = useCallback(()=>{
    setLoading(true)
    console.log("getting survey Info")
    surveyService.getEcxSurveyById(adminClinicId,surveyId)
    .then(res=>{
       console.log(res.data)
       console.log("data values")
       console.log(res.data.data)
       setSurvey(res.data)
       setLoading(false)
    })
    .catch(err=>{
      console.log(err)
      setLoading(false)
    })
  },[adminClinicId,surveyId,setSurvey])

  useEffect(()=>{
    console.log("Edit Survey")
    resetSurvey()
    getSurveyInfo()


  },[surveyId,adminClinicId,resetSurvey,getSurveyInfo])

  const handleSave = async () => {
    try {
      const surveyData = exportToJSON();
      
      // Add templateType to survey (icon and iconColor are in editor defaults)
      const surveyWithAdditionalFields = {
        ...surveyData.survey,
        templateType: surveyData.survey.templateType || 'ECX_SURVEY'
      };
      
      const requestData = {
        ...surveyData,
        survey: surveyWithAdditionalFields
      };
      
      const response = await surveyService.updateEcxSurvey(adminClinicId, surveyId, requestData);
      console.log('Survey updated successfully:', response.data);
      toast.success('Survey updated successfully!');
    } catch (error) {
      console.error('Error updating survey:', error);
      toast.error('Failed to update survey. Please try again.');
    }
  }

  return (
    <>
    {loading ? <Loading/>:
   
   <EcxSurveyEditor onSave={handleSave} />}
    </>
  )
}

export default SurveyEdit